import { render, staticRenderFns } from "./DocNumber.vue?vue&type=template&id=09d59d6c&scoped=true"
import script from "./DocNumber.vue?vue&type=script&lang=js"
export * from "./DocNumber.vue?vue&type=script&lang=js"
import style0 from "./DocNumber.vue?vue&type=style&index=0&id=09d59d6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d59d6c",
  null
  
)

export default component.exports